import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  agendaSelector,
  peopleSelector,
  agendaEditSelector,
  agendaLoadingSelector,
  agendaSavingSelector,
  editAgenda,
  cancelEditAgenda,
  saveAgenda,
  updateAgendaDay,
  addAgendaDay,
  removeAgendaDay,
  updateAgendaItem,
  removeAgendaItem,
  addAgendaItem,
  removePersonFromAgendaDay,
  addPersonToAgendaDay,
  uploadAgendaItemMedia,
  agendaItemMediaSavingSelector,
  setAgendaDayPeople,
  clearAgendaDayPeople,
  addAgendaDayAccommodationRoom,
  removeAgendaDayAccommodationRoom,
  addPersonToAccommodationRoom,
  removePersonFromAccommodationRoom,
} from '../../../reducers';
import ManageAgenda from './component';

const mapStateToProps = (state) => {
  return {
    agenda: agendaSelector(state) || {},
    agendaEdit: agendaEditSelector(state),
    people: peopleSelector(state) || {},
    loading: agendaLoadingSelector(state) ? true : false,
    saving: agendaSavingSelector(state) ? true : false,
    uploadingImage: agendaItemMediaSavingSelector(state) || [],
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    editAgenda,
    cancelEditAgenda,
    saveAgenda,
    updateAgendaDay,
    addAgendaDay,
    removeAgendaDay,
    updateAgendaItem,
    removeAgendaItem,
    addAgendaItem,
    removePersonFromAgendaDay,
    addPersonToAgendaDay,
    uploadAgendaItemMedia,
    setAgendaDayPeople,
    clearAgendaDayPeople,
    addAgendaDayAccommodationRoom,
    removeAgendaDayAccommodationRoom,
    addPersonToAccommodationRoom,
    removePersonFromAccommodationRoom,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageAgenda);



// WEBPACK FOOTER //
// ./src/component/organisms/ManageAgenda/index.js